var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isNoResults)?_c('DataTableRepresentation',_vm._g({ref:"data_table_representation",staticClass:"input-item-container",attrs:{"canChooseItems":"","isTableFocused":"","listKey":_vm.resultsKey,"input":_vm.filteredItems,"searchString":_vm.searchString,"overrideTableTitle":_vm.overrideTableTitle}},_vm.$listeners)):_c('NoDataFoundMessage')
}
var staticRenderFns = []

export { render, staticRenderFns }